function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#026BB6;stroke:#026BB6;}\n\t.st2{fill:none;stroke:#E2E7EC;stroke-width:11.7;stroke-linecap:round;}\n\t.st3{fill:none;}\n\t.st4{opacity:0.95;fill:none;stroke:#FFFFFF;stroke-width:3.9878;stroke-linecap:round;enable-background:new    ;}\n\t.st5{opacity:0.9;fill:none;stroke:#FFFFFF;stroke-width:2;enable-background:new    ;}\n\t.st6{opacity:0.9;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{opacity:0.9;fill:#E2E7EC;enable-background:new    ;}\n\t.st8{fill:#999999;}\n\t.st9{font-family:'Arial-BoldItalicMT';}\n\t.st10{font-size:5px;}\n\t.st11{font-family:'Arial-ItalicMT';}\n\t.st12{fill:none;stroke:#B7B7B7;stroke-width:0.5;}\n\t.st13{fill:none;stroke:#B7B7B7;stroke-width:0.5;stroke-dasharray:0.9538,0.9538;}\n\t.st14{fill:#888888;}\n\t.st15{font-size:4px;}\n\t.st16{font-family:'ArialMT';}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st1",
  cx: 0,
  cy: -21.6,
  r: 12.4
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("line", {
  className: "st2",
  x1: 15.7,
  y1: 40.2,
  x2: 148.7,
  y2: 40.4
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st4",
  x1: 15.7,
  y1: 40.2,
  x2: 91.7,
  y2: 40.3
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 15.7,
  y1: 40.2,
  x2: 15.7,
  y2: 40.2
}), React.createElement("line", {
  className: "st5",
  x1: 82.2,
  y1: 34.9,
  x2: 82.2,
  y2: 45.6
}), React.createElement("circle", {
  className: "st6",
  cx: 148.7,
  cy: 40.4,
  r: 1
}), React.createElement("circle", {
  className: "st6",
  cx: 126.6,
  cy: 40.3,
  r: 1
}), React.createElement("circle", {
  className: "st6",
  cx: 104.4,
  cy: 40.3,
  r: 1
}), React.createElement("circle", {
  className: "st7",
  cx: 82.3,
  cy: 40.3,
  r: 1
}), React.createElement("circle", {
  className: "st7",
  cx: 60.1,
  cy: 40.2,
  r: 1
}), React.createElement("circle", {
  className: "st7",
  cx: 38,
  cy: 40.2,
  r: 1
}), React.createElement("circle", {
  className: "st7",
  cx: 16.2,
  cy: 40.1,
  r: 1
}));

var _ref5 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 103.4044 7.9074)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  className: "st8 st9 st10"
}, "Twice "), React.createElement("tspan", {
  x: 15.3,
  y: 0,
  className: "st8 st11 st10"
}, "as specialized"), React.createElement("tspan", {
  x: 0,
  y: 6,
  className: "st8 st11 st10"
}, "as all the countries"));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
  className: "st12",
  x1: 104.4,
  y1: 33.5,
  x2: 104.4,
  y2: 33
}), React.createElement("line", {
  className: "st13",
  x1: 104.4,
  y1: 32.1,
  x2: 104.4,
  y2: 17.3
}), React.createElement("line", {
  className: "st12",
  x1: 104.4,
  y1: 16.8,
  x2: 104.4,
  y2: 16.3
})));

var _ref7 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 124.7691 50.0441)",
  className: "st14 st11 st15"
}, "x4");

var _ref8 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 146.6626 50.0443)",
  className: "st14 st11 st15"
}, "x8");

var _ref9 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 18.7758 7.9075)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  className: "st8 st9 st10"
}, "Half "), React.createElement("tspan", {
  x: 10.8,
  y: 0,
  className: "st8 st11 st10"
}, "as specialized"), React.createElement("tspan", {
  x: 0.6,
  y: 6,
  className: "st8 st11 st10"
}, "as all the countries"));

var _ref10 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
  className: "st12",
  x1: 60.1,
  y1: 33.5,
  x2: 60.1,
  y2: 33
}), React.createElement("line", {
  className: "st13",
  x1: 60.1,
  y1: 32.1,
  x2: 60.1,
  y2: 17.3
}), React.createElement("line", {
  className: "st12",
  x1: 60.1,
  y1: 16.8,
  x2: 60.1,
  y2: 16.3
})));

var _ref11 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 34.6018 50.044)",
  className: "st14 st11 st15"
}, "1/4");

var _ref12 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 12.7617 50.0441)",
  className: "st14 st11 st15"
}, "1/8");

var _ref13 =
/*#__PURE__*/
React.createElement("line", {
  className: "st12",
  x1: 91.7,
  y1: 60.1,
  x2: 91.7,
  y2: 41.2
});

var _ref14 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 62.7431 65.8848)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  className: "st8 st16 st10"
}, "Specialization Inde"), React.createElement("tspan", {
  x: 42,
  y: 0,
  className: "st8 st16 st10"
}, "x"), React.createElement("tspan", {
  x: 44.3,
  y: 0,
  className: "st8 st16 st10"
}, " score"));

var _ref15 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 57.0173 50.0438)",
  className: "st14 st11 st15"
}, "1/2");

var _ref16 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1 0 0 1 102.3482 50.0437)",
  className: "st14 st11 st15"
}, "x2");

var SvgSiLegend = function SvgSiLegend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "spain",
    x: "0px",
    y: "0px",
    viewBox: "0 0 166.3 73.8",
    style: {
      enableBackground: "new 0 0 166.3 73.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("g", {
    className: "st0"
  }, _ref3, React.createElement("text", {
    pointerEvents: "none",
    transform: "matrix(1 0 0 1 5 -26.6276)",
    className: "st16",
    style: {
      display: "inline",
      fill: "#014B7F",
      enableBackground: "new",
      fontSize: "14.9336px"
    }
  }, "Spain")), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSiLegend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SI-legend.7bb2d408.svg";
export { ForwardRef as ReactComponent };